<template>
  <!-- <template v-if="limit > 0 && record.length > limit">
    <a-tooltip placement="top">
      <template #title>
        {{ recordStr }}
      </template>

      <a-tag v-for="(item, index) in limitRecord" :key="index" :color="color">
        {{ item }}
      </a-tag>
    </a-tooltip>
  </template>
  <template v-else> -->
  <a-tag v-for="(item, index) in record" :key="index" :color="color">
    {{ item }}
  </a-tag>
  <!-- </template> -->
</template>

<script lang="ts">
import _ from "lodash";
import { computed, defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "ArrayDescription",
  props: {
    // 一位数组, e.g. ['你好', '中国']
    dataSource: {
      type: Array,
      default: [],
    },

    // Tag 标签的 color
    color: {
      type: String,
      default: "",
    },

    // 展示多少个标签
    limit: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const record = computed(() => {
      if (!_.isArray(props.dataSource)) {
        return [];
      }
      return props.dataSource.filter(_.isString).filter(Boolean);
    });

    const limitRecord = computed(() => {
      if (props.limit === 0) {
        return [];
      }
      if (!_.isArray(props.dataSource)) {
        return [];
      }
      return props.dataSource.filter(_.isString).filter(Boolean).slice(0, props.limit);
    });

    const recordStr = computed(() => {
      if (!_.isArray(props.dataSource)) {
        return [];
      }
      return props.dataSource.filter(_.isString).filter(Boolean).join("，");
    });
    return {
      record,
      limitRecord,
      recordStr,
    };
  },
});
</script>
